module.exports = __webpack_public_path__ + "files/bd41c41dde4f138551d8a4867fdf63ac.png";